import {Button} from "@/components/ui/button.tsx";
import {ScrollArea} from "@/components/ui/scroll-area.tsx";
import {SidebarInset, SidebarProvider} from "@/components/ui/sidebar.tsx";
import {PageHeader} from "@ozon-ai/components/header/header.tsx";
import {AppSidebar} from "@ozon-ai/components/sidebar/app-sidebar.tsx";
import {useEffect, useState} from "react";
import {Outlet} from "react-router-dom";
import {BreadcrumbPageTitleProvider} from "../routes/breadcrumb-page-title";
import type {BackgroundTask} from "@ozon-ai/ozon/contracts";
import {api} from "../api/client";
import {
	BackgroundTasksPanel,
	backgroundTasksPanelContext,
} from "./BackgroundTasksPanel";

export function Layout() {
	const [open, setOpen] = useState(false);
	const [tasks, setTasks] = useState<BackgroundTask[]>([]);
	const [watchToken, setWatchToken] = useState(0);
	const activeCount = tasks.filter(
		(task) => task.status === "queued" || task.status === "running",
	).length;

	useEffect(() => {
		let cancelled = false;
		let timer = 0;

		async function load() {
			try {
				const next = await api.get<BackgroundTask[]>("/debug/background-tasks");
				if (cancelled) return;
				setTasks(next);
				const stillActive = next.some(
					(task) => task.status === "queued" || task.status === "running",
				);
				if (stillActive) timer = window.setTimeout(() => void load(), 1000);
			} catch {
				// Список подтянется при следующем открытии панели.
			}
		}

		void load();
		return () => {
			cancelled = true;
			window.clearTimeout(timer);
		};
	}, [watchToken]);

	function openPanel() {
		setOpen(true);
		setWatchToken((value) => value + 1);
	}

	return (
		<backgroundTasksPanelContext.Provider value={{openPanel}}>
			<BreadcrumbPageTitleProvider>
			<SidebarProvider>
				<AppSidebar/>
				<SidebarInset className="min-h-0 overflow-hidden">
					<div className="relative flex h-full min-h-0 w-full flex-col overflow-hidden bg-background">
						<ScrollArea className="layout-page min-h-0 w-full flex-1 overflow-hidden">
							<div className="layout-page-inner flex min-h-full w-full flex-col">
								<PageHeader/>
								<div className="layout-page-outlet">
									<Outlet/>
								</div>
							</div>
						</ScrollArea>

						{/* Background tasks */}
						<div className="flex shrink-0 justify-center border-t border-border bg-background">
							<Button
								variant="ghost"
								size="sm"
								onClick={openPanel}
							>
								{activeCount > 0
									? `Активные задачи (${activeCount})`
									: "Активные задачи"}
							</Button>
						</div>
					</div>
				</SidebarInset>
			</SidebarProvider>
			</BreadcrumbPageTitleProvider>
			{open && (
				<BackgroundTasksPanel tasks={tasks} onClose={() => setOpen(false)}/>
			)}
		</backgroundTasksPanelContext.Provider>
	);
}
